<template>
  <div>
      <van-nav-bar title="专属会员签约更改" left-text="" left-arrow @click-left="onClickLeft()" />

      <div style="height:600px;overflow-y:auto;">
        <van-divider content-position="left">专属会员签约奖励</van-divider>
      <div style="text-align:center;">
        <img src="../../assets/draw2025/sign_rule.jpg" style="width:100%;margin-top:2%;" />
      </div>
      
      <div class="table_detail" style="margin-top:10px;">
      <table>
        <thead>
          <tr>
            <th>序号</th>
            <th>签约单量</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ 1 }}</td>
            <td v-if="signNum==20" style="color:red;">{{ 20 }}(当前签约)</td>
            <td v-else>{{ 20 }}</td>
            <td v-if="taskCount==1||updateBy==1||signNum==20"><van-button type="primary" size="small" @click="sign(20,1)" disabled>签约更改</van-button></td>
            <td v-else><van-button type="primary" size="small" @click="sign(20,1)">签约更改</van-button></td>
          </tr>
          <tr>
            <td>{{ 2 }}</td>
            <td v-if="signNum==40" style="color:red;">{{ 40 }}(当前签约)</td>
            <td v-else>{{ 40 }}</td>
            <td v-if="taskCount==1||updateBy==1||signNum==40"><van-button type="primary" size="small" @click="sign(40,2)" disabled>签约更改</van-button></td>
            <td v-else><van-button type="primary" size="small" @click="sign(40,2)">签约更改</van-button></td>
          </tr>
          <tr>
            <td>{{ 3 }}</td>
            <td v-if="signNum==60" style="color:red;">{{ 60 }}(当前签约)</td>
            <td v-else>{{ 60 }}</td>
            <td v-if="taskCount==1||updateBy==1||signNum==60"><van-button type="primary" size="small" @click="sign(60,3)" disabled>签约更改</van-button></td>
            <td v-else><van-button type="primary" size="small" @click="sign(60,3)">签约更改</van-button></td>
          </tr>
          <tr>
            <td>{{ 4 }}</td>
            <td v-if="signNum==80" style="color:red;">{{ 80 }}(当前签约)</td>
            <td v-else>{{ 80 }}</td>
            <td v-if="taskCount==1||updateBy==1||signNum==80"><van-button type="primary" size="small" @click="sign(80,4)" disabled>签约更改</van-button></td>
            <td v-else><van-button type="primary" size="small" @click="sign(80,4)">签约更改</van-button></td>
          </tr>
        </tbody>
      </table>
    </div> 
      </div>
         
  </div>    
</template>

<script>
import { NavBar, Dialog, Divider } from "vant";
import { Button } from "vant";

export default {
  name: "LuckDrawRecord",
  data() {
    return {      
      currentPage: 1,
      drawList: [],
      loading: false, 		// 是否处在加载状态
      finished: false, 		// 是否已加载完成
      total: 0,				    // 数据总条数
      pageCount: 0,       // 总页数
      pageSize: 0,    // 每页条数
      signNum:0,
      taskCount:0,
      updateBy:0,
    };
  },
  props: {},
  computed:{
    isLogined(){return this.$store.state.isLogin}
  },
  methods: {
    ShowLogin(){
      this.$store.commit("showLogin");
    },
    
    sign(num,level) {
      var that = this;
      Dialog.confirm({
        title: "VIP签约",
        message:
          "每人可更改签约一次，是否确认更改，签约成功后不允许更改?",
      }).then(() => {
        // on confirm
        that.$http.get("Activity2025/MemberSignEdit", {
          params: {
            processNum:num,
            level:level
          },
        }).then((res) => {
          if (res.data == "success") {
            that.$toast("签约更改成功！");
            that.$router.push({
              name: "SignReward",
              params: {},
            });           
          } else {
            that.$toast(res.data);
          }
        });
      })
      .catch(() => {
        // on cancel
      });
    },
    GetSign() {
      var that = this;
      this.$http.get("Activity2025/GetSign", {
        params: {
        },
      }).then((res) => {
        that.signNum = res.data.Data.SignNum;
        that.taskCount = res.data.Data.TaskCount;
        that.updateBy = res.data.Data.UpdateBy;
      });
    },
    /*返回 */
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  created() {
    this.GetSign();
  },
  components: {
    [Button.name]: Button,
    [NavBar.name]:NavBar,
    [Dialog.name]: Dialog,
    [Divider.name]: Divider,
  },
};
</script>

<style scoped>
  .table_detail{
    overflow:auto;
    width: 100%;
    /* 固定滚动高度 */
    max-height: calc(100vh - 220px);
    border-top: 1px solid #EBEBEB;
    border-bottom: 1px solid #EBEBEB;
    border-right: 0;
    
  }
  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
  }
  td, th {
    border-right: 1px solid #EBEBEB;
    border-bottom :1px solid #EBEBEB;
    width:100px;
    height: 35px;
    color: #333;
    box-sizing: border-box;
    background-color: #ffffff;
    font-size: 12px;
    text-align: center;
    padding: 5px 5px 5px 0;
  }
  th {
    background: #FAFAFA;
    color: #999;
    font-weight: normal;
  }
  /* 固定首列*/
  td:first-child,
  th:first-child {
    width:100px;
    position:sticky;
    left:0;
    z-index:1;
    padding-left: 5px;
  }
  /* 固定表头*/
  thead tr th {
    position:sticky;
    top:0;
  }
  th:first-child{
    z-index:2;
  }
  /* 固定表头*/
  tfoot tr th {
    position:sticky;
    bottom:0;
    color: #333;
    font-weight: bold;
    border-bottom: 0;
  }
  th:first-child{
    z-index:2;
  }

</style>
